import { postFoundingsSearch } from 'services/portfolios';
import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { TPostFoundingsSearch } from '@dekafvv/sharedfrontend';

export const usePostFoundingsSearch = ({
    clientId,
    body,
    refetchOnMount = true,
    enabled = true,
}: {
  clientId: string;
  //   Type definition could be changed/ For now it is created for specific request
  body: {
    page: number;
    pageSize: number;
    targetAccountIds: number[];
    isActive: boolean;
  };
  refetchOnMount?: boolean;
  enabled?: boolean;
}) => {
    const query = useQuery<
    AxiosResponse<TPostFoundingsSearch>,
    null | { message: string },
    TPostFoundingsSearch
  >({
      queryKey: ['postFoundingsSearch', 'shared', clientId, body],
      queryFn: () => postFoundingsSearch(clientId, body).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
      enabled,
  });

    return query;
};
